import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { X } from 'lucide-react';

// Shared in-site YouTube embed modal — used anywhere a reaction video should
// play inline instead of navigating away to YouTube (Home/Explore reactions,
// MySpace notifications, etc.).
const VideoEmbedModal = ({ videoId, title, startSeconds = 0, onClose }) => {
  const embedOrigin = typeof window !== 'undefined' ? window.location.origin : '';
  const embedParams = new URLSearchParams({
    autoplay: '1',
    rel: '0',
    origin: embedOrigin,
    start: String(Math.max(0, Number(startSeconds) || 0))
  }).toString();

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return ReactDOM.createPortal(
    <div
      onClick={onClose}
      style={{
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        background: 'rgba(0,0,0,0.88)', zIndex: 9999,
        display: 'flex', alignItems: 'center', justifyContent: 'center'
      }}
    >
      <button
        onClick={(e) => { e.stopPropagation(); onClose(); }}
        style={{
          position: 'absolute', top: '16px', right: '20px',
          background: 'rgba(255,255,255,0.12)', border: 'none',
          borderRadius: '50%', width: '36px', height: '36px',
          color: '#fff', cursor: 'pointer',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          zIndex: 10000
        }}
      >
        <X size={18} />
      </button>
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          position: 'relative', width: '90vw', maxWidth: '960px',
          aspectRatio: '16/9', background: '#000',
          borderRadius: '12px', overflow: 'hidden',
          boxShadow: '0 24px 80px rgba(0,0,0,0.7)'
        }}
      >
        <iframe
          src={`https://www.youtube-nocookie.com/embed/${videoId}?${embedParams}`}
          title={title || 'Reaction video'}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          referrerPolicy="strict-origin-when-cross-origin"
          style={{ width: '100%', height: '100%', border: 'none', display: 'block' }}
        />
      </div>
    </div>,
    document.body
  );
};

export default VideoEmbedModal;
